var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 11.75H11M7.25 14.75H11M7.25 17.75H11M14 18.5H16.25C16.8467 18.5 17.419 18.2629 17.841 17.841C18.2629 17.419 18.5 16.8467 18.5 16.25V5.858C18.5 4.723 17.655 3.76 16.524 3.666C16.15 3.63498 15.7756 3.60831 15.401 3.586M15.401 3.586C15.4674 3.80109 15.5001 4.02491 15.5 4.25C15.5 4.44891 15.421 4.63968 15.2803 4.78033C15.1397 4.92098 14.9489 5 14.75 5H10.25C9.836 5 9.5 4.664 9.5 4.25C9.5 4.019 9.535 3.796 9.6 3.586M15.401 3.586C15.118 2.668 14.262 2 13.25 2H11.75C11.2692 2.00011 10.8011 2.15414 10.4143 2.43954C10.0274 2.72493 9.74203 3.1267 9.6 3.586M9.6 3.586C9.224 3.609 8.85 3.636 8.476 3.666C7.345 3.76 6.5 4.723 6.5 5.858V8M6.5 8H3.125C2.504 8 2 8.504 2 9.125V20.375C2 20.996 2.504 21.5 3.125 21.5H12.875C13.496 21.5 14 20.996 14 20.375V9.125C14 8.504 13.496 8 12.875 8H6.5ZM5 11.75H5.008V11.758H5V11.75ZM5 14.75H5.008V14.758H5V14.75ZM5 17.75H5.008V17.758H5V17.75Z",
    stroke: "#080808",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.7f172c89a1ed9f7c88207035f660d63b.svg";
export { ForwardRef as ReactComponent };